export interface ResponseModel<Type> {
    count: number;
    data: Type;
    page: number;
    pageCount: number;
    total: number;
}
